module.exports = __webpack_public_path__ + "images/banners/kaitori_bonus_campaign/banner_campaign202007_small_3356f79a61586e17a12e92a8f9b6985d.jpg";